import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../commonComponents/translate';
import LevelCard from './LevelCard';

const LevelObjectives = props => {
  const { t, data } = props;

  return (
    <div className="level-objectives">
      <div className="level-objectives-header">
        <div className="career-section-title">
          {t('report.mivitana.objectives.levelObjectives')}
        </div>
      </div>
      <div className="level-objectives-content">
        <div className="level-objectives-labels-table">
          <table
            className="table table-striped m-table"
            style={{ width: '100%' }}
          >
            <tbody>
              <tr className="content" key="row-1">
                <td className="contentCell">
                  {t('report.mivitana.objectives.personalPV')}
                </td>
              </tr>
              <tr className="content" key="row-3">
                <td className="contentCell">
                  {t('report.mivitana.objectives.recruitGoal')}
                </td>
              </tr>
              <tr className="content" key="row-2">
                <td className="contentCell">
                  {t('report.mivitana.objectives.totalPVWeakLegs')}
                </td>
              </tr>
              <tr className="content" key="row-4">
                <td className="contentCell">
                  {t('report.mivitana.objectives.SponsorsAtLeastInOneLeg')}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="level-card-container">
          {data.map((levelData, index) => (
            <LevelCard
              key={levelData.level}
              t={t}
              index={index}
              levelData={levelData}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

LevelObjectives.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      level: PropTypes.number.isRequired,
      skillLevel: PropTypes.shape({
        icon: PropTypes.string,
        name: PropTypes.string,
      }).isRequired,
      personalPV: PropTypes.shape({
        limit: PropTypes.number,
        limitAchieved: PropTypes.bool,
      }).isRequired,
      totalPVWeakLegs: PropTypes.shape({
        limit: PropTypes.number,
        limitAchieved: PropTypes.bool,
      }).isRequired,
      recruitGoal: PropTypes.shape({
        limit: PropTypes.number,
        limitAchieved: PropTypes.bool,
      }).isRequired,
      recruitGoalLevel: PropTypes.number.isRequired,
      SponsorsAtLeastInOneLeg: PropTypes.shape({
        limit: PropTypes.string,
        limitAchieved: PropTypes.bool,
      }).isRequired,
    }),
  ).isRequired,
};

export default translate(LevelObjectives);
